import styled from '@emotion/styled';

export const Card = styled.div`
  border: 0.063rem solid ${({ theme }) => theme.color.light1};
  border-radius: 0.5rem;
  padding: 2rem;
`;
